/**
 * @destription 外圈控制形状
 * @author duanjun
 */

import { IPoint } from './interface';
interface IOptions {
    width: number;
    height: number;
}

export default class Sharp {
    public static area(a: number, b: number) {
        return a * b * Math.PI;
    }

    public static calcuAxis(area: number, ratio: number) {
        const a = Math.sqrt(area / Math.PI / ratio);
        const b = ratio * a;
        return {
            a,
            b,
        };
    }

    public width: number;
    public height: number;
    private origin: IPoint;
    private canvas: HTMLCanvasElement;
    private context: CanvasRenderingContext2D;
    private imageData: ImageData;
    private filledImageData: ImageData;
    constructor(options: IOptions) {
        const { width, height } = options;
        this.width = width;
        this.height = height;
        this.origin = {
            x: width / 2,
            y: height / 2,
        };
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d') as CanvasRenderingContext2D;
        this.canvas.height = this.height;
        this.canvas.width = this.width;
        this.ellipse(this.origin.x, this.origin.y, this.width / 2, this.height / 2);
        this.imageData = this.getImageData();
        this.filledImageData = this.getImageData();
    }

    public getImageData() {
        return this.context.getImageData(0, 0, this.width, this.height);
    }

    public isPointFilled(x: number, y: number) {
        if (this.isPointInSharp(x, y)) {
            const index = (this.width * Math.max(y - 1, 0) + x) * 4 - 1;
            return this.filledImageData.data[index] === 0;
        }
        return true;
    }

    public isPointInSharp(x: number, y: number) {
        if (x <= 0 || y <= 0 || x > this.width || y > this.height) {
            return false;
        }
        const index = (this.width * Math.max(y - 1, 0) + x) * 4 - 1;
        return this.imageData.data[index] > 0;
    }

    public clearRect(x: number, y: number, width: number, height: number) {
        const context = this.context;
        context.clearRect(x, y, width, height);
        this.filledImageData = this.getImageData();
    }

    public ellipse(x: number, y: number, a: number, b: number) {
        const context = this.context;
        const step = (a > b) ? 1 / a : 1 / b;
        context.beginPath();
        context.moveTo(x + a, y);
        for (let i = 0; i < 2 * Math.PI; i += step) {
            context.lineTo(x + a * Math.cos(i), y + b * Math.sin(i));
        }
        context.closePath();
        context.fill();
    }

    /**
     * @description 获取椭圆径向填充点坐标
     * @param {number} a 长轴
     * @param {number} b 短轴
     * @param {number} rad 弧度
     */

    public getFillPoint(a: number, b: number, rad: number) {
        return {
            x: Math.round(this.origin.x + a * Math.cos(rad)),
            y: Math.round(this.origin.y + b * Math.sin(rad)),
        };
    }
}

